import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideMainLoading, HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {reminderInterface, tuitionInterface} from "../students/details";
import {ThinPrintIcon, TomansIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";

export const PrintStudentTuitionScreen = () => {
    const {studentId} = useParams();
    const [data, setData] = useState({
        firstname: '',
        lastname: '',
        tuition: [] as tuitionInterface[], // paid
        tuitionMode: "dept" as "dept" | "upfront" | "free",
        tuitionTotalPrice: 0,
        isTuitionSet: false,
        tuitionPercentPaid: 0,
        tuitionPaidSoFar: 0,
        extraProgramCost: 0,
        offAmount: 0,
    });
    const [remindersList, setRemindersList] = useState([] as reminderInterface[]);
    const fetchData = () => {
        HideMainLoading();
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/details',
            {id: studentId as string},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                firstname: string,
                lastname: string,
                national: string,
                grade: number,
                fatherName: string,
                birthSerial: string,
                homeTell: string,
                fatherJob: string,
                motherName: string,
                motherTell: string,
                motherCert: string,
                motherJob: string,
                zipcode: string,
                address: string,
                balance: number,
                maxBuyPerDay: number,
                isInside: 0 | 1,
                canWrite: boolean,
                tuition: tuitionInterface[] | null,
                tuitionMode: "dept" | "upfront" | "free",
                smsIfEnter: boolean,
                smsIfExit: boolean,
                smsIfAbsent: boolean,
                tuitionPrice: number,
                defaultTuition: number,
                reminders: reminderInterface[] | null,
                birthDate: string,
                fatherTell: string,
                fatherCert: string,
                classId: number,
                className: string,
                defaultExtraProgramCost: number,
                extraProgramCost: number,
                offAmount: number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if (d.reason === 'not-found') {
                        ShowSnackbar('دانش‌آموز مورد نظر یافت نشد.', 'باشه', 5000);
                    }
                    return;
                }
                let paidSoFar = 0;
                let paidPercent = 0;
                if (d.tuition !== null && d.tuitionPrice > 0) {
                    d.tuition.forEach(t => {
                        paidSoFar += t.price;
                    });
                    paidPercent = (paidSoFar * 100) / d.tuitionPrice; // >0 makes sure DIVISION_BY_ZERO not happen
                }
                setRemindersList(d.reminders === null ? [] : d.reminders);
                setData({
                    firstname: d.firstname,
                    lastname: d.lastname,
                    tuition: d.tuition === null ? [] : d.tuition,
                    tuitionMode: d.tuitionMode,
                    isTuitionSet: d.tuitionPrice !== -1,
                    tuitionTotalPrice: d.tuitionPrice < 0 ? 0 : d.tuitionPrice,
                    tuitionPaidSoFar: paidSoFar,
                    tuitionPercentPaid: paidPercent,
                    extraProgramCost: d.extraProgramCost,
                    offAmount: d.offAmount,
                });
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "پرینت پرونده مالی | نهال";
        fetchData();
    }, []);
    return (
        <>
            <div className="print-screen">
                <button onClick={window.print}>
                    <ThinPrintIcon/>
                    پرینت
                </button>
                <b>گزارش دانش‌آموز {data.firstname + " " + data.lastname}</b>
                <span>اطلاعات کلی شهریه</span>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-12">
                            <div style={{
                                padding: 20,
                                border: '2px solid #e1e1e1',
                                borderRadius: 10,
                                textAlign: 'start'
                            }}>
                                <div className="row justify-content-center">
                                    <div className="col-lg-4">
                                        <div className="tuition-status">
                                            <span className={""}>وضعیت</span>
                                            <b className={""}>{!data.isTuitionSet ? 'نامشخص' : (data.tuitionPercentPaid === 100 || data.tuitionTotalPrice === 0 ? 'تکمیل شده' : 'بدهکار')}</b>
                                            <strong>{CurrencyFormat(data.tuitionPercentPaid.toFixed(0))}٪
                                                پرداخت
                                                شده</strong>
                                            {data.extraProgramCost > 0 ?
                                                <em className={""}
                                                    style={{textAlign: 'start', padding: 0, color: '#000'}}>دارای فوق
                                                    برنامه
                                                    ({CurrencyFormat(data.extraProgramCost)} تومان)</em> : null}
                                            {data.offAmount > 0 ?
                                                <em className={""} style={{
                                                    textAlign: 'start',
                                                    padding: 0,
                                                    color: '#000',
                                                }}> {CurrencyFormat(data.offAmount)} تومان تخفیف اعمال
                                                    شده است.</em> : null}
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="d-lg-none" style={{height: 20}}/>
                                        <div className="tuition-status">
                                            <span className={""}>پرداخت شده</span>
                                            <p className={""}
                                               style={{color: 'darkgreen'}}>{CurrencyFormat(data.tuitionPaidSoFar)}
                                                <TomansIcon/></p>
                                        </div>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="tuition-status">
                                            <span className={""}>بدهکاری</span>
                                            <p className={""}
                                               style={{color: '#8b0000'}}>{CurrencyFormat(data.tuitionTotalPrice - data.tuitionPaidSoFar)}
                                                <TomansIcon/></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <b>گزارش‌های پرداختی دانش‌آموز</b>
                <span>{data.firstname + " " + data.lastname}</span>
                {
                    data.tuition.length > 0 ?
                        <>
                            <table className="table open-table table-stripped table-bordered"
                                   style={{display: 'table!important', border: 0}}>
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>مبلغ</th>
                                    <th>وضعیت</th>
                                    <th>تاریخ پرداخت</th>
                                    <th>نوع پرداخت</th>
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    data.tuition.map((t, i) =>
                                        <tr key={"U23j82nD123" + i}>
                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td>
                                                <span>{CurrencyFormat(t.price)}<TomansIcon/></span>
                                            </td>
                                            <td>پرداخت شده</td>
                                            <td>{StringDigitsConvertToPersian(GregorianToPersian(t.paidAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                            <td>{t.payMethod === 'old' ? 'سامانه قدیم' : (t.payMethod === 'cash' ? 'فیش' : 'آنلاین')}</td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </> : <div className="staff--not-found">
                            <b>پرداختی یافت نشد</b>
                            <p>هنوز پرداختی برای شهریه صورت نگرفته است.</p>
                        </div>
                }
            </div>
        </>
    );
};